<template>

<app-view-list-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

    <core-divisive :score="item.users.divisiveness" :count="item.users.totalRatings" />

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky']

}

</script>

<style scoped>

</style>